import script from "./reservation-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./reservation-list.vue?vue&type=script&setup=true&lang=ts"

import "./reservation-list.vue?vue&type=style&index=0&id=49a02fa6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a02fa6"]])

export default __exports__